import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { PageStoryblok } from "~/generated/sb/blok-types";

export const PageBlok = ({ blok, preview }: BlokProps<PageStoryblok>) => {
	return (
		<BlokWrap editable={blok} as="main">
			{blok?.body
				? blok?.body?.map((currentBlok, i) => {
						return (
							<StoryblokComponent
								blok={currentBlok}
								key={`${blok._uid}-${currentBlok._uid}`}
								firstElement={i === 0}
								preview={preview}
							/>
						);
					})
				: null}
		</BlokWrap>
	);
};
